import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const STATUS_COLORS: Record<string, string> = {
  delivered:  'hsl(142, 72%, 42%)',
  in_transit: 'hsl(217, 91%, 60%)',
  assigned:   'hsl(262, 80%, 60%)',
  picked_up:  'hsl(190, 70%, 50%)',
  pending:    'hsl(38, 92%, 50%)',
  failed:     'hsl(0, 84%, 60%)',
  cancelled:  'hsl(0, 0%, 60%)',
};

const STATUS_LABELS: Record<string, string> = {
  delivered:  'تم التوصيل',
  in_transit: 'قيد النقل',
  assigned:   'مُعيَّن',
  picked_up:  'تم الاستلام',
  pending:    'قيد الانتظار',
  failed:     'فشل',
  cancelled:  'ملغى',
};

interface Props {
  data: { status: string; count: number }[];
}

export function StatusDonutChart({ data }: Props) {
  if (!data.length) {
    return (
      <div className="flex items-center justify-center h-[220px] text-muted-foreground text-sm">
        لا توجد بيانات
      </div>
    );
  }

  const total = data.reduce((s, d) => s + d.count, 0);

  const chartData = data.map((d) => ({
    name: STATUS_LABELS[d.status] ?? d.status,
    value: d.count,
    color: STATUS_COLORS[d.status] ?? 'hsl(0,0%,50%)',
  }));

  return (
    <div className="relative h-[220px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius="55%"
            outerRadius="75%"
            paddingAngle={2}
            dataKey="value"
          >
            {chartData.map((entry, i) => (
              <Cell key={i} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{ background: 'hsl(var(--background))', border: '1px solid hsl(var(--border))', borderRadius: 8, fontSize: 12 }}
            formatter={(v: any, name: string) => [v, name]}
          />
          <Legend wrapperStyle={{ fontSize: 11 }} />
        </PieChart>
      </ResponsiveContainer>
      {/* Center label */}
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
        <span className="text-2xl font-bold">{total}</span>
        <span className="text-xs text-muted-foreground">إجمالي</span>
      </div>
    </div>
  );
}
